import { FORM_NAME } from '%paysera_simple_event/js/event/component/Form/config/constants';
import { getFormValues } from 'redux-form';
import { createSelector } from 'reselect';

export default createSelector(
    state => getFormValues(FORM_NAME)(state),
    (ticketTypes, hash) => hash,
    ({ ticket_types: ticketTypes }, hash) => {
        const ticketType = ticketTypes.find(type => type.hash === hash);
        const soldTicketsCount = ticketType.sold_tickets_count;

        return Number(soldTicketsCount);
    },
);
